export default "__VITE_ASSET__B8$zm7r9__"